<template>
  <div class="ModeratorMenue">

    <md-button :md-ripple="false" class="md-icon-button" @click="toggleModeratorMenue">
        <AccountCog/>
    </md-button>	

    <transition name="slideDown">
        <md-list class="mm-list" v-if="moderatorMenueVisible">
        
            <!-- Screensharing -->
            <md-list-item  @click="toggleScreenSharingHere(); toggleModeratorMenue();" :class="{'mm-list-item-active': screenSharingActive}"> 
                <MonitorShareIcon class="md-list-item-icon"/>
                <span v-if="!screenSharingActive" class="md-list-item-text">{{ $t('Bildschirm teilen') }}</span>
                <span v-else class="md-list-item-text">{{ $t('Bildschirm teilen abbrechen') }}</span>
            </md-list-item>

            <!-- Follow Moderator mode -->
            <md-list-item @click="toggleFollowModeratorMode(); toggleModeratorMenue();" :class="{'mm-list-item-active': sendingFollowModerator}"> 
                <Eye class="md-list-item-icon"/>
                <span v-if="!sendingFollowModerator" class="md-list-item-text">{{ $t('Geführter Modus aktivieren') }}</span>
                <span v-else class="md-list-item-text">{{ $t('Geführter Modus deaktivieren') }}</span>
            </md-list-item>

            <!-- Mute all -->
            <md-list-item  @click="muteAll(); toggleModeratorMenue();"> 
                <VolumeOff class="md-list-item-icon"/>
                <span class="md-list-item-text">{{ $t('Alle Teilnehmer stummschalten') }}</span>
            </md-list-item>

            <!-- VideoOff all -->
            <md-list-item  @click="stopVideoAll(); toggleModeratorMenue();"> 
                <VideoOff class="md-list-item-icon"/>
                <span class="md-list-item-text">{{ $t('Videos aller Teilnehmer ausstellen') }}</span>
            </md-list-item>

            <!-- Remove all -->
            <md-list-item  @click="removeAll(); toggleModeratorMenue();"> 
                <AccountOff class="md-list-item-icon"/>
                <span class="md-list-item-text">{{ $t('Alle Teilnehmer Entfernen') }}</span>
            </md-list-item>

        </md-list>
    </transition>

  </div>
</template>

<script>
import {mapGetters, mapState, mapMutations} from "vuex";
import MonitorShareIcon from 'vue-material-design-icons/MonitorShare.vue'
import AccountCog from 'vue-material-design-icons/AccountCog.vue'
import VolumeOff from 'vue-material-design-icons/VolumeOff.vue'
import VideoOff from 'vue-material-design-icons/VideoOff.vue'
import AccountOff from 'vue-material-design-icons/AccountOff.vue'
import Eye from 'vue-material-design-icons/Eye.vue'

export default {
    components:{MonitorShareIcon,AccountCog,VolumeOff,VideoOff,AccountOff,Eye},
    inject: ['toggleScreenSharing'],
    data: () => ({
        moderatorMenueVisible: false,
        screenSharingActive: false,
        intervalID: null,
    }),
    computed:{
        ...mapGetters(['users',"localUserID",'currentSituationID','isDialogueOpen','sendingFollowModerator']),
        ...mapState({
            session: (state) => state.session.openTokSession,
            openTokStreams: (state) => state.session.openTokStreams,
        }),
    },
    mounted: function(){
        window.addEventListener("toggleFollowModeratorMode",this.toggleFollowModeratorMode);
    },
    methods:{
        ...mapMutations(["requestUsersToMe",'setSendingFollowModerator']),
        toggleModeratorMenue() {
			this.moderatorMenueVisible = !this.moderatorMenueVisible;
		},
        toggleScreenSharingHere(){
            this.screenSharingActive = !this.screenSharingActive;
            this.toggleScreenSharing();
        },
        toggleFollowModeratorMode(){
            this.setSendingFollowModerator(!this.sendingFollowModerator);
            
            // Activate follow me mode
            if(this.sendingFollowModerator){
                this.intervalID = setInterval(() => {
                    let camera = window.scene.getCameraByName("MainCamera");
                    const signalData = {
                        type: "followModerator", 
                        data: this.localUserID + " " + camera.alpha + " " + camera.beta + " " + this.currentSituationID,
                    };
                    this.session.signal(signalData, function (error) {
                        if(error) console.log(['signal error (', error.code, '): ', error.message].join(''));
                        else console.log('followModerator signal sent');   
                    });
                }, 20);

            // Deactivate follow me mode
            }else{
                clearInterval(this.intervalID);
            }
            
        },
        muteAll(){
            // Inefficient: should only send 1 signal that mutes all users except Moderator (openTok signal gets send to all other users)
            this.users.forEach(u => {
                if(u.id != this.localUserID){
                    const signalData = {
                        type: "mute", 
                        data: u.id,
                    };
                    this.session.signal(signalData, function (error) {
                        if (error) 
                            console.log(['signal error (', error.code, '): ', error.message].join(''));
                        else 
                            console.log('mute signal sent');   
                    });
                }
            });
        },
        stopVideoAll(){
            // Inefficient: should only send 1 signal that mutes all users except Moderator (openTok signal gets send to all other users)
            this.users.forEach(u => {
                if(u.id != this.localUserID){
                    const signalData = {
                        type: "stopVideo", 
                        data: u.id,
                    };
                    this.session.signal(signalData, function (error) {
                        if (error) 
                            console.log(['signal error (', error.code, '): ', error.message].join(''));
                        else 
                            console.log('mute signal sent');   
                    });
                }
            });
        },
        removeAll(){
            this.users.forEach(u => {
                if(u.id != this.localUserID){
                    let connection = this.openTokStreams.filter( x => x.connection.data.user_id == u.id )[0].connection;
                    this.session.forceDisconnect(connection, function (error) {
                        if (error) 
                            console.log(error);
                        else 
                            console.log("Connection forced to disconnect: " + connection.id);
                    });
                }
             });
        },
    },
}

</script>

<style scoped>
.ModeratorMenue{
    position: relative;
}
.mm-list{
    position: absolute;
    background: white;
    filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.5));
    z-index: 10;
    padding: 0;
    width: 300px;
    left: -125px;
    top: 50px;
    max-height: 250px;
    overflow: hidden;
}
.mm-list-item-active{
    background: var(--secondaryColor);
}
.mm-list .material-design-icon {
	height: 25px;
	width: 25px;
}
.mm-list .material-design-icon > .material-design-icon__svg {
    fill: rgb(78, 78, 78);
    height: 25px;
    width: 25px;
}
.md-list-item-icon{
    margin-right: 10px;
}
.md-list-item-text{
    font-size: 14px;
}
.md-list-item:hover .material-design-icon > .material-design-icon__svg{
    fill: var(--primaryColor);
}
.md-list-item:hover .md-list-item-text{
    color: var(--primaryColor);
}

/* SituationGallery SlideDown/SlideUp animation */
.slideDown-enter-active, .slideDown-leave-active {
	transition: max-height .2s ease-in-out;
}
.slideDown-enter, .slideDown-leave-to {
	max-height: 0px !important;
}
</style>